export const moneyOriginValuesSchemaOtherBlacklist = ['false', 'student', 'studuji', 'studium'];
